import { api } from './index';

const BASE_PATH = '/api/internal/transbank';

export const transbankApi = {
  createInscription() {
    const path = `${BASE_PATH}/create_inscription`;

    return api({
      method: 'post',
      url: path,
    }).then(response => response.data);
  },
  payBooking(productBookingId:number) {
    const path = `${BASE_PATH}/pay_booking`;

    return api({
      method: 'post',
      url: path,
      data: { productBookingId },
    });
  },
  payDeposit(productBookingId:number) {
    const path = `${BASE_PATH}/pay_deposit`;

    return api({
      method: 'post',
      url: path,
      data: { productBookingId },
    });
  },
};
